import { PreferencesService } from './../preferences-avis-de-pub/services/preferences.service';
import { Component, OnInit } from '@angular/core';
import { HomeAvisDePubMessages } from '../../shared/models/component-messages/home-avisDePub-messages.ts';
import { Title } from '@angular/platform-browser';
import { AuthorizationService } from '../../../authorization/services/authorization.service';
import { EnumMicroDroits } from '../../administration/models/micro.droits';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-home',
  templateUrl: './home-avis-de-pub.component.html',
  styleUrls: ['./home-avis-de-pub.component.scss']
})
export class HomeAvisDePubComponent implements OnInit {
  public homeAvisDePubMessages = new HomeAvisDePubMessages();
  displayPreference: boolean = false;

  isCreateAvailable: Observable<boolean>;
  isListAvailable: Observable<boolean>;
  isPreferenceAvailable: Observable<boolean>;


  constructor(private preferencesService: PreferencesService, private titleService:Title, private authorizationService: AuthorizationService) {
  }

  public ngOnInit( ) {
    this.displayPreference=this.preferencesService.displayPreference();
    this.titleService.setTitle('Avis de publicité - Accueil');
    this.habilitations();
  }

  private habilitations() {
    this.isCreateAvailable = this.authorizationService.hasAnyMicroRightIn([EnumMicroDroits.AVIS_PUBLICITE_GESTION]);
  
    this.isListAvailable = this.authorizationService.hasAnyMicroRightIn([
      EnumMicroDroits.AVIS_PUBLICITE_CONSULTATION,
      EnumMicroDroits.AVIS_PUBLICITE_GESTION
    ]);

    this.isPreferenceAvailable = this.authorizationService.hasAnyMicroRightIn([
      EnumMicroDroits.COMPTES_ANNONCEURS_GESTION,
      EnumMicroDroits.COMPTES_ANNONCEURS_CONSULTATION,
      EnumMicroDroits.DONNEES_FACTURATIONS_GESTION,
      EnumMicroDroits.DONNEES_FACTURATIONS_CONSULTATION
    ]);
  }

}
